<template>
  <div>
    <div :class="$style['banner-wrapper']">
      <MCALegacyBanner :name="firstName" feature="Capital Advances" />
      <MessageDocumentRequests />
      <TheTaxesMessageBanner />
      <Message
        v-if="
          pureValidAdvanceUser && waitListBannerContent && showNewProductBanner
        "
        severity="info"
        :closable="true"
        @close="closeNewProductBanner"
      >
        <h3>
          {{ $t(waitListBannerContent.title, { firstName }) }}
        </h3>
        <p v-if="waitListBannerContent.paragraph1">
          {{ $t(waitListBannerContent.paragraph1, { firstName }) }}
        </p>
        <p v-if="waitListBannerContent.paragraph2">
          {{ $t(waitListBannerContent.paragraph2) }}
        </p>
        <p v-else-if="waitListBannerContent.cta">
          <a @click="joinWaitlist">{{ $t(waitListBannerContent.cta) }}</a>
        </p>
      </Message>
    </div>
    <router-view />
    <PayAnInvoiceModal ref="payAnInvoicePopup" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { waitlistBannerText } from '@/data/payments';
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';
import Message from 'primevue/message';
import PayAnInvoiceModal from '@/components/PayAnInvoiceModal/index.vue';
import TheTaxesMessageBanner from '@/components/banners/TheTaxesMessageBanner.vue';
import MessageDocumentRequests from '@/components/banners/MessageDocumentRequests.vue';
import MCALegacyBanner from '@/pages/mca/components/MCALegacyBanner.vue';
import { subMonths } from 'date-fns';
import { LocalStorage, LocalStorageKeys } from '@/utils/local-storage';

export default {
  components: {
    Message,
    PayAnInvoiceModal,
    TheTaxesMessageBanner,
    MessageDocumentRequests,
    MCALegacyBanner,
  },
  computed: {
    ...mapGetters([
      'user',
      'business',
      'pureValidAdvanceUser',
      'userCategory',
      'businessCorpCountry',
      'businessId',
      'userHasForceBnplFlag',
      'bills',
      'showNewProductBanner',
      'intendedPrimaryOrPrimaryBankAccount',
    ]),
    waitListBannerContent() {
      return waitlistBannerText(
        this.userCategory,
        this.businessCorpCountry,
        this.userHasForceBnplFlag,
        this.bills.length > 0,
      );
    },
    firstName() {
      if (!this.user.firstName) return 'Hello';
      return (
        this.user.firstName.charAt(0).toUpperCase() +
        this.user.firstName.slice(1)
      );
    },
  },
  async beforeMount() {
    const statementStartDate = subMonths(new Date(), 6).toISOString();

    await this.$store.dispatchApiAction('GET_BANK_STATEMENTS_CHECK', {
      statementStartDate,
      bankAccountNumber:
        this.intendedPrimaryOrPrimaryBankAccount?.accountNumber,
    });
  },
  async created() {
    if (this.business.id)
      this.$store.dispatchApiAction('FETCH_USER_CARDS', { canceled: false });

    await this.$store.dispatchApiAction('GET_DOCUMENT_REQUESTS');
  },
  methods: {
    joinWaitlist() {
      this.$refs.payAnInvoicePopup.open(this.businessId);
      analytics.track(SEGMENT_EVENTS.CLEARPAY_BNPL_WAITLISTED, {
        email: this.user.email,
        name: this.user.fullName,
        businessId: this.businessId,
        businessName: this.business.name,
      });
    },
    closeNewProductBanner() {
      LocalStorage.setItem(LocalStorageKeys.HIDE_PHOENIX_INTRO_BANNER, true);
    },
  },
};
</script>

<style lang="less" scoped>
:deep(.p-message-text p) {
  font-weight: 400;
  text-align: left;
  margin: 0;
}
</style>
<style lang="less" module>
.banner-wrapper {
  max-width: @wayfinding-tablet-width;
  margin: auto;
  padding: 0 40px;

  @media only screen and (min-width: 513px) and (max-width: 1024px) {
    padding: 0 @spacing-40;
  }

  // mobile
  @media only screen and (max-width: 512px) {
    padding: 0 @spacing-16;
  }
}
</style>
